import styled from "styled-components";

const StyledProgramNavigation = styled.div`
  padding: 0 0 2rem;
  a {
    color: ${(props) => props.theme.darkGrey};
    &:hover {
      color: ${(props) => props.theme.primaryBlue};
    }
  }
`;

export default StyledProgramNavigation;
